(() => {
  window.MenoPlayAfterTimeline?.destroy();

  const controllers = new Map();
  const lifecycle = new AbortController();
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const destroy = (id) => {
    controllers.get(id)?.abort();
    controllers.delete(id);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-menoplay-pdp-module="after"]').forEach((root) => {
      const id = root.dataset.sectionId || 'after';
      const journey = root.querySelector('.menoplay-pdp-post-journey');
      const steps = [...root.querySelectorAll('.menoplay-pdp-post-step')];

      if (!journey || !steps.length) return;

      destroy(id);
      const controller = new AbortController();
      const { signal } = controller;
      controllers.set(id, controller);
      root.classList.add('has-timeline-animation');

      const supplyCta = root.querySelector('[data-menoplay-pdp-select-supply-days]');
      supplyCta?.addEventListener('click', (event) => {
        const buyBox = document.getElementById('buybox');
        const variantSelect = buyBox?.querySelector('[data-menoplay-pdp-variant-select]');
        const supplyDays = supplyCta.dataset.menoplayPdpSelectSupplyDays;
        const option = variantSelect?.querySelector(`option[data-menoplay-pdp-supply-days="${supplyDays}"][data-available="true"]`);

        if (buyBox) {
          event.preventDefault();
          if (option && variantSelect.value !== option.value) {
            variantSelect.value = option.value;
            variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
          buyBox.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        }
      }, { signal });

      let frame;
      const update = () => {
        frame = undefined;
        const progress = reduceMotion.matches
          ? 1
          : Math.min(Math.max((window.innerHeight * 0.72 - journey.getBoundingClientRect().top) / (journey.offsetHeight + window.innerHeight * 0.18), 0), 1);

        journey.style.setProperty('--route-progress', progress.toFixed(3));
        journey.classList.toggle('is-route-visible', progress > 0);
        steps.forEach((step, index) => step.classList.toggle('is-visible', progress >= 0.05 + index * 0.2));
      };
      const requestUpdate = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true, signal });
      window.addEventListener('resize', requestUpdate, { signal });
      reduceMotion.addEventListener('change', requestUpdate, { signal });
      signal.addEventListener('abort', () => frame && cancelAnimationFrame(frame), { once: true });
      update();
    });
  };

  document.addEventListener('shopify:section:load', (event) => init(event.target), { signal: lifecycle.signal });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-menoplay-pdp-module="after"]')
      ? event.target
      : event.target.querySelector?.('[data-menoplay-pdp-module="after"]');
    if (root) destroy(root.dataset.sectionId || 'after');
  }, { signal: lifecycle.signal });
  window.MenoPlayAfterTimeline = {
    destroy: () => {
      lifecycle.abort();
      controllers.forEach((controller) => controller.abort());
      controllers.clear();
    },
  };
  init();
})();
